module.exports = __webpack_public_path__ + "static/media/pay.ef22d1c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pay.svg
// module id = ./src/assets/icons/pay.svg
// module chunks = 0